export * from './catalog-layers-tool.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/catalog-layers-tool/index.ts